var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25837,0,0,1,-109.772,-169.149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.915,209.574C881.915,187.263 867.52,169.149 849.789,169.149L119.359,169.149C101.629,169.149 87.234,187.263 87.234,209.574L87.234,290.426C87.234,312.737 101.629,330.851 119.359,330.851L849.789,330.851C867.52,330.851 881.915,312.737 881.915,290.426L881.915,209.574Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25837,0,0,1,-109.772,389.716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.915,209.574C881.915,187.263 867.52,169.149 849.789,169.149L119.359,169.149C101.629,169.149 87.234,187.263 87.234,209.574L87.234,290.426C87.234,312.737 101.629,330.851 119.359,330.851L849.789,330.851C867.52,330.851 881.915,312.737 881.915,290.426L881.915,209.574Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25837,0,0,1,-109.772,669.149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.915,209.574C881.915,187.263 867.52,169.149 849.789,169.149L119.359,169.149C101.629,169.149 87.234,187.263 87.234,209.574L87.234,290.426C87.234,312.737 101.629,330.851 119.359,330.851L849.789,330.851C867.52,330.851 881.915,312.737 881.915,290.426L881.915,209.574Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25837,0,0,1,-109.772,110.284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.915,209.574C881.915,187.263 867.52,169.149 849.789,169.149L119.359,169.149C101.629,169.149 87.234,187.263 87.234,209.574L87.234,290.426C87.234,312.737 101.629,330.851 119.359,330.851L849.789,330.851C867.52,330.851 881.915,312.737 881.915,290.426L881.915,209.574Z",
    style: {
      fill: "white"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/list-view-icon.fe320fb5edad5380f493548171efe5d0.svg";
export { ForwardRef as ReactComponent };